import React from "react";
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#d1f00f',
      main: '#9ebefd',
      dark: '#6c8eca',
      contrastText: '#1a66ff',
    },
  },
});

function PaletteButton(props) {
  if (props.twoButton) {
    return (
      <MuiThemeProvider theme={props.theme}>
        <div className="laplaceDialogCenter">
          <Button style={{margin:'10px',width:'180px',boxShadow:'none'}} variant="contained" color="primary" size="large" onClick={props.firstButtonFunc}>{props.firstButtonText}</Button>
          <Button style={{margin:'10px',width:'180px',boxShadow:'none'}} variant="contained" color="secondary" size="large" onClick={props.secondButtonFunc}>{props.secondButtonText}</Button>
        </div>
      </MuiThemeProvider>
    );
  } else {
    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <Button style={{margin:'10px',width:'180px',boxShadow:'none'}} variant="contained" color="primary" size="large" onClick={props.firstButtonFunc}>{props.firstButtonText}</Button>
        </div>
      </MuiThemeProvider>
    );
  }
}
/*
  それぞれのボタンにはオリジナルのメソッドを割り当てて良い
  左が1番目ボタン, 右が2番目ボタン
  onExitにこのダイアログが閉じたときに動いてほしい動作を与える。デフォルトはCloseするだけ
  firstButtonTextに値を与えない場合は自動で `OK` になる
  2ボタンの場合はtheme上書き可能。デフォルトは青色ボタン
*/

export default class LapDialog extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
    };
  }
  handleClose = () => {
    this.props.toClose();
  };
  checkHaveSecond = () => {
    if (!this.props.hasOwnProperty('secondButtonText')) {
      return false;
    }
    if (this.props.secondButtonText === '') {
      return false;
    }
    return true;
  }
  checkAutoCancel = () => {
    if (!this.props.hasOwnProperty('firstButtonText')) {
      return true;
    }
    if (this.props.hasOwnProperty.firstButtonText === '') {
      return true;
    }
    return false;
  }

  judgeAction = () => {
    if (this.checkHaveSecond()) {
      // 2ボタン
        return(
          <DialogActions>
            <PaletteButton
              theme={this.props.theme}
              twoButton={true}
              firstButtonFunc={this.props.firstButtonFunc}
              firstButtonText={this.props.firstButtonText}
              handleClose={this.handleClose}
              secondButtonFunc={this.props.secondButtonFunc}
              secondButtonText={this.props.secondButtonText}
            />
          </DialogActions>
        );
    } else {
      // 1ボタン
      if (this.checkAutoCancel()) {
        return(
          <DialogActions>
            <PaletteButton
              twoButton={false}
              firstButtonFunc={this.handleClose}
              firstButtonText='OK'
            />
          </DialogActions>
        );
      } else {
        return(
          <DialogActions>
            <PaletteButton
              twoButton={false}
              firstButtonFunc={this.props.firstButtonFunc}
              firstButtonText={this.props.firstButtonText}
            />
          </DialogActions>
        );
      }
    }
  }
  showElements = () => {
    if (this.props.contentText) {
      return (
        <DialogContentText id="alert-dialog-description">
          {this.props.contentText}
        </DialogContentText>
      );
    } else {
      return this.props.contentElem;
    }
  }
  render() {
    // DialogTitleはcontentがrequiredなため
    let dialogTitle = '';
    if (this.props.title) {
      dialogTitle = this.props.title;
    }

    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={false}
          className="laplaceDialogWidth"
          onExit={this.props.onExit}
        >
          <DialogTitle className="laplaceDialogTitle" id="alert-dialog-title" >{dialogTitle}</DialogTitle>
          <DialogContent className="laplaceDialogContent">
            {this.showElements()}
          </DialogContent>
          <hr className="laplaceDialogHr" />
          {this.judgeAction()}
        </Dialog>
      </div>
    );
  }
}

LapDialog.propTypes = {
  title: PropTypes.string,
  firstButtonText: PropTypes.string,
  firstButtonFunc: PropTypes.func,
  secondButtonText: PropTypes.string,
  open: PropTypes.bool.isRequired,
  toClose: PropTypes.func.isRequired,
  onExit: PropTypes.func,
  theme: PropTypes.object,
  contentText: PropTypes.string,
  contentElem: PropTypes.element,
};


